export default [{
    path: 'operationsLog',
    redirect: '/operationsLog/Business',
    children: [{
        path: '/operationsLog/Business',
        meta: {
            title: "业务运维记录",
            name: 'Business',
            keepAlive: true
        },
        components: {
            mains: () => import('../views/operationsLog/Business.vue')
        }
    },{
        path: '/operationsLog/Instance',
        meta: {
            title: "服务器运维记录",
            name: 'Instance',
            keepAlive: true
        },
        components: {
            mains: () => import('../views/operationsLog/Instance.vue')
        }
    } ]
}]